import React, { useState } from "react";

const Page11 = () => {

  const [selectedIndex, setSelectedIndex] = useState(0);

  return (
    <div className="moc-page">
      {/* ESQUERDA */}
      <div className="moc-left" style={{ paddingTop: '240px', paddingLeft: '150px' }}>        
        <img src="./img/module1/page11.svg" alt="" style={{ width: '90%' }} />
      </div>

      {/* DIREITA */}      
      <div className="moc-right" style={{ paddingTop: '100px' }}>
        <p>Nem todos os impactos de uma mudança aparecem de forma imediata, alguns podem surgir ao longo do tempo, e é exatamente por isso que a avaliação prévia é essencial.</p>
        <p>Na Bayer, toda mudança passa por uma análise sob a ótica de HSE, com o suporte do MOC, antes de ser implementada.</p>
        <p>Esse cuidado ajuda a antecipar riscos, proteger as pessoas, o meio ambiente e garantir operações seguras, especialmente no que se refere ao Process & Plant Safety (PPS), que assegura a integridade dos processos e das instalações. Vamos entender melhor como isso funciona, a seguir.</p>
      </div>

      <style>{`

        .container{
          width: 100% !important;
        }

        /* ROOT DA PÁGINA */
        .moc-page {
          display: flex;
          height: 100%;
          overflow: hidden;
        }

        /* COLUNA DIREITA */
        .moc-right {
          width: 50%;
          background: #c2c2c2;
          padding: 30px;
          box-sizing: border-box;

          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
        }

        /* COLUNA ESQUERDA */
        .moc-left {
          width: 50%;
          padding-top: 250px;
          background: #c2c2c2;
          color: #000000;
          padding: 40px;
          box-sizing: border-box;        }

        .moc-left p {
          white-space: pre-line;
          line-height: 1.6;
        }

        /* ================= MOBILE ================= */
        @media (max-width: 768px) {

          .moc-page {
            flex-direction: column;
            // height: auto;
          }

          .moc-left,
          .moc-right {
            width: 100%;
            padding: 20px;
          }

          .moc-left {
            padding-top: 100px !important;
          }

          .moc-right {
            padding-top: 0px !important;
          }

          .moc-right img {
            width: 100%;
            max-width: 300px;
          }

        }

      `}</style>
    </div>
  );
};

export default Page11;